// crewbit-admin/src/components/money/DisputeStatusPill.tsx
//
// Tier 2-UI Phase E (in-app bundle) — admin parity for mobile DisputeStatusPill.
// 4-state pill with tone mapping per §E-inapp.D3:
//   opened             → amber (urgent attention)
//   evidence_submitted → blue/accent (in progress)
//   won                → green (resolved favorably)
//   lost               → red (resolved unfavorably)
//
// Web idiom: inline CSS via styles/tokens. Distinct from SettingsStatusPill
// (settings semantics) and common StatusPill (invoice statuses).

import { palette, radii, spacing } from '../../styles/tokens';
import type { DisputeStatus } from '../../types/disputes';

interface Tone {
  bg: string;
  fg: string;
}

const TONE: Record<DisputeStatus, Tone> = {
  opened: { bg: palette.amberWash, fg: palette.amber },
  evidence_submitted: { bg: palette.accentWash, fg: palette.accent },
  won: { bg: palette.greenWash, fg: palette.green },
  lost: { bg: palette.redWash, fg: palette.red },
};

interface DisputeStatusPillProps {
  status: DisputeStatus;
  label: string;
}

export default function DisputeStatusPill({ status, label }: DisputeStatusPillProps) {
  const tone = TONE[status];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignSelf: 'flex-start',
        background: tone.bg,
        color: tone.fg,
        borderRadius: radii.sm,
        padding: `${spacing.xs}px ${spacing.sm}px`,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: 0.3,
        textTransform: 'uppercase',
      }}
    >
      {label}
    </span>
  );
}
